import React from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  Button,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { useNotification } from "Hooks/NotificationManager";
import Discover from "../../../Assets/Icons/PaymentIcon/Discover.jpg";
import AmericanExpress from "../../../Assets/Icons/PaymentIcon/american-express.png";
import MasterCard from "../../../Assets/Icons/PaymentIcon/Mastercard.png";
import Visa from "../../../Assets/Icons/PaymentIcon/Visa.png";
import SecureIcon from "../../../Assets/Icons/PaymentIcon/secureIcon.png";
import Amex from "../../../Assets/Icons/PaymentIcon/Amex.png";
import Group from "../../../Assets/Icons/PaymentIcon/Group.png";
import { before } from "underscore";

const useStyle = makeStyles((theme) => ({
  csMainPayment: {
    "& .StripeElement": {
      display: "block",
      margin: "10px 10px 10px 10px",
      maxWidth: "500px",
      padding: "10px 14px",
      fontSize: "1em",
      border: `1px solid #5A6872 `,
      fontFamily: "Poppins,sans-serif",
      outline: "0",
      height: "40px",
      borderRadius: "5px",
      background: `${theme.palette.white.main} !important`,
    },
    "& .StripeElement.PaymentRequestButton": {
      height: "40px",
    },
  },
  csTitleText: {
    paddingLeft: "10px",
    paddingRight: "10px",
    marginBottom: "10px",
    fontSize: "15px",
    fontWeight: "500 !important",
    display: "flex",
    whiteSpace: "nowrap",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "25px !important",
  },

  csPayBtn: {
    padding: "5px 85px !important",
  },
  invalidStripeElement: {
    borderColor: "#fa755a !important",
  },
  imgpayment: {
    width: "100%",
    height: "40px",
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
    marginTop: "-13px",
    "&>img": {
      paddingLeft: "5px",
      width: "auto",
      height: "20px",
    },
  },
  erortext: {
    marginLeft: "10px !important",
    [theme.breakpoints.down("380")]: {
      marginBottom: "5px !important",
    },
  },
}));

const CARD_ELEMENT_OPTIONS = {
  placeholder: "Card Number",
  style: {
    base: {
      color: "#50505099",
      fontFamily: "Poppins,sans-serif",
      fontWeight: "400",
      fontSmoothing: "antialiased",

      fontSize: "13px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
      border: "1px solid #fa755a !important",
    },
  },
  hidePostalCode: true, // Hide postal code field
};

export default function Payment({
  cardError,
  setCardError,
  options,
  getLoginUserAction,
  setOpen,
  apiResult,
  setApiResult,
}) {
  const classes = useStyle();
  const stripe = useStripe();
  const elements = useElements();
  const notification = useNotification();
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    const result = await stripe.confirmCardPayment(options.clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: "Cardholder Name",
        },
      },
    });
    setCardError("");
    if (result.error) {
      setCardError(result.error);
      notification.error(result.error.message);
    } else {
      setApiResult(true);
      setOpen(false);
      getLoginUserAction();
      notification.success(
        `Payment successful: ${result.paymentIntent.status}`
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        columnSpacing={2.5}
        rowSpacing={3}
        className={classes.csMainPayment}
      >
        <Grid item xs={12}>
          <Box className={classes.csTitleText}>
            Card Details
            {/* <Box className={classes.imgpayment}>
              <img src={Visa} alt="Card Icon" width="100" height="100" />
              <img src={MasterCard} alt="Card Icon" width="100" height="100" />
              <img src={DiscoverIcon} alt="Card Icon" width="100" height="90" />
              <img
                src={AmericanExpress}
                alt="Card Icon"
                width="100"
                height="90"
              />
            </Box> */}
          </Box>
          <CardElement
            CardNumberElement
            options={{
              ...CARD_ELEMENT_OPTIONS,
              classes: {
                invalid: cardError ? classes.invalidStripeElement : "",
              },
            }}
          />
          {cardError && (
            <FormHelperText
              className={classes.erortext}
              error={cardError?.message ? cardError.message : ""}
            >
              {cardError?.message ? cardError.message : ""}
            </FormHelperText>
          )}
        </Grid>
        <Box className={classes.imgpayment}>
          <img src={Visa} alt="Card Icon" width="100" height="100" />
          <img src={MasterCard} alt="Card Icon" width="100" height="100" />
          <img src={Amex} alt="Card Icon" width="100" height="90" />
          <img src={Discover} alt="Card Icon" width="100" height="90" />
        </Box>

        <Grid item xs={12} marginTop={"-20px !important"}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            className={classes.csPayBtn}
          >
            <Button
              variant="contained"
              type="submit"
              disabled={!stripe}
              startIcon={
                !stripe && <CircularProgress color="white" size="20px" />
              }
              style={{ marginTop: "15px", width: "117px", height: "39px" }}
            >
              Pay Now
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={2}
            marginTop={"-5px"}
          >
            <img src={Group} alt="Powered by Stripe" width="15" />
            <Box ml={2} fontSize="15px" color="grey.600" marginLeft="5px">
              Secure payment powered by Stripe
            </Box>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
